<p-multiSelect
  [options]="comparisonValues"
  [(ngModel)]="selection"
  placeholder="Vergleichswert auswählen"
  optionLabel="name"
  optionValue="key"
  display="chip"
  [showHeader]="comparisonValues.length > 5"
  (ngModelChange)="onSelectionChange($event)"
  [showClear]="true" />
